import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import {Link} from 'react-router-dom';

class ProjectGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      gridActive: false,
      preloadCover: null
    }
  }

  onMouseEnter = (e) => {
    this.setState({
      gridActive: true
    });
    if(e.target.dataset.cover !== undefined) {
      this.setState({
        preloadCover: e.target.dataset.cover
      })
    }
  }

  onMouseLeave = (e) => {
    this.setState({
      gridActive: false
    })
  }
  render() {
    const projects = DataStore.getAllProjects();
    //<img src={project.acf.thumb.url} alt={project.title.rendered} className="thumb-svg" />
    //<object type="image/svg+xml" aria-label="project graphic" data={project.acf.thumb.url} className="thumb-svg"></object>

    return (
      <section className={`project-grid ${this.state.gridActive ? 'grid-active' : ''}`}>
        <div className="cnt">
          {projects.map((project, i)=>{
            if(project.id !== this.props.currentProject)
            return <Link to={'/projects/' + project.slug} key={i}
                        className={`project ${this.props.currentProject === project.id ? 'current': ''}`}
                        onMouseEnter={this.onMouseEnter}
                        onMouseLeave={this.onMouseLeave}
                        data-cover={project.acf.cover.url}
                    >

              <div className="thumb">
                <img src={project.acf.thumb.url} alt={project.title.rendered} className="thumb-svg" />
              </div>
              <div className="details">
                <div className="title" dangerouslySetInnerHTML={{__html:project.title.rendered}} />
                <div className="location">{project.acf.location}</div>
              </div>
              <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
              <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
              <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
              <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
            </Link>
          })}
        </div>
        <div className="preload-cover">
          {this.state.preloadCover !== null ?
            <img scr={this.state.preloadCover} alt="preloading cover" />: null
          }
        </div>
      </section>
    );
  }
}

export default ProjectGrid;



// WEBPACK FOOTER //
// ./src/scripts/components/project-grid.js